import React from 'react';
import {observer} from "mobx-react";
import {VideoPlayButtonBox} from "./boxes/video-play-button.box";
import {IVideoPlayerViewModel} from "../../../services/video/models/video-player.view-model.interface";
import {NullableUndefinedString} from "../../../../common/types/nullable-types";
import {TimeSpan} from "@sparkware/app-utils";

interface VideoPlayButtonComponentProps {
    videoPlayer: IVideoPlayerViewModel;
    src: string;
    poster: NullableUndefinedString;
    watchTimeLimit: TimeSpan | undefined;
}
export const VideoPlayButtonComponent: React.FC<VideoPlayButtonComponentProps> = observer((props) => {
    const onClickHandler = async () => {
        await props.videoPlayer.play(props.src, {
            poster: props.poster,
            watchTimeLimit: props.watchTimeLimit
        });
    }

    if(!props.videoPlayer.isPaused || props.videoPlayer.watchTimeLimitReached) {
        return null;
    }

    return (
        <VideoPlayButtonBox onClick={onClickHandler}/>
    )
});

